// Korean translations
export const ko: Record<string, string> = {
  // Main Menu
  'menu.dashboard': '대시보드',
  'menu.orderNew': '제품 등록',
  'menu.deliveryList': '배송 목록',
  'menu.delivery': '배송',
  'menu.receipt': '영수증/라벨 인쇄',
  'menu.definitions': '정의',
  'menu.customers': '고객',
  'menu.products': '제품 정의',
  'menu.pricing': '가격 정의',
  'menu.tailoring': '재봉 작업',
  'menu.attributes': '제품 속성',
  'menu.users': '사용자',
  'menu.productOrdering': '제품 순서',
  'menu.discounts': '할인 정의',
  'menu.settings': '설정',
  'menu.generalSettings': '일반 설정',
  'menu.permissions': '권한 관리',
  'menu.subscription': '구독',
  'menu.invoices': '청구서 관리',
  'menu.expenses': '비용 입력',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': '보고서 및 회계',
  'menu.systemAndCommunication': '시스템 및 커뮤니케이션',
  'menu.reportsList': '영수증 목록',
  'menu.accountStatement': '계정 명세서',
  'menu.tickets': '지원 요청',
  'menu.support': '지원',
  'menu.profile': '프로필',
  'menu.logout': '로그아웃',
  'menu.notifications': 'SMS/WhatsApp 알림',
  'menu.whatsappConnection': 'WhatsApp 연결',
  'menu.smsConnection': 'SMS 연결',
  
  // Dashboard
  'dashboard.title': '대시보드',
  'dashboard.todaySales': '오늘 판매',
  'dashboard.totalOrders': '총 주문',
  'dashboard.pendingDeliveries': '배송 대기',
  'dashboard.activeCustomers': '활성 고객',
  'dashboard.recentOrders': '최근 주문',
  'dashboard.viewAll': '모두 보기',
  'dashboard.quickActions': '빠른 작업',
  'dashboard.newOrder': '새 주문',
  'dashboard.newCustomer': '새 고객',
  'dashboard.deliveries': '배송',
  'dashboard.reports': '보고서',
  'dashboard.today': '오늘',
  'dashboard.yesterday': '어제',
  'dashboard.week': '주',
  'dashboard.month': '월',
  'dashboard.quarter': '분기',
  'dashboard.year': '년',
  'dashboard.totalRevenue': '총 수익',
  'dashboard.totalOrdersCard': '총 주문',
  'dashboard.totalPieces': '총 항목',
  'dashboard.cancelled': '취소됨',
  'dashboard.inProcess': '처리 중',
  'dashboard.inProcessDesc': '처리 중인 주문',
  'dashboard.ready': '준비 완료',
  'dashboard.readyDesc': '배송 준비 완료 주문',
  'dashboard.delivered': '배송 완료',
  'dashboard.deliveredDesc': '완료된 주문',
  'dashboard.announcements': '공지사항',
  'dashboard.announcementAll': '일반',
  'dashboard.announcementPrivate': '개인',
  
  // Order Entry
  'order.title': '새 주문',
  'order.customer': '고객',
  'order.selectCustomer': '고객 선택',
  'order.newCustomer': '새 고객',
  'order.products': '제품',
  'order.addProduct': '제품 추가',
  'order.selectProduct': '제품 선택',
  'order.quantity': '수량',
  'order.price': '가격',
  'order.total': '합계',
  'order.discount': '할인',
  'order.subtotal': '소계',
  'order.tax': '부가가치세',
  'order.grandTotal': '총합계',
  'order.payment': '결제',
  'order.paymentMethod': '결제 방법',
  'order.cash': '현금',
  'order.card': '신용카드',
  'order.credit': '외상',
  'order.amountPaid': '지불 금액',
  'order.remainingBalance': '잔액',
  'order.deliveryDate': '배송 날짜',
  'order.notes': '메모',
  'order.createOrder': '주문 생성',
  'order.cancel': '취소',
  
  // Users
  'users.title': '사용자',
  'users.addNew': '새 사용자',
  'users.name': '이름',
  'users.email': '이메일',
  'users.role': '역할',
  'users.pin': 'PIN',
  'users.permissions': '권한',
  'users.allPermissions': '모든 권한',
  'users.permissionCount': '{count} 권한',
  'users.changePin': 'PIN 변경',
  'users.edit': '편집',
  'users.delete': '삭제',
  'users.newUser': '새 사용자',
  'users.editUser': '사용자 편집',
  'users.editingUser': '{name} 편집 중',
  'users.deleteUserTitle': '사용자 삭제',
  'users.deletingUser': '{name}을(를) 삭제하시겠습니까?',
  'users.pinCode': 'PIN 코드 (4-6자리)',
  'users.selectRole': '역할 선택',
  'users.patron': '소유자',
  'users.kasiyer': '계산원',
  'users.sofor': '운전기사',
  'users.eleman': '직원',
  'users.changePinTitle': 'PIN 코드 변경',
  'users.newPin': '새 PIN 코드',
  'users.confirmPin': 'PIN 코드 확인',
  'users.pinMismatch': 'PIN 코드가 일치하지 않습니다',
  'users.pinRequired': 'PIN 코드 필요',
  'users.pinLength': 'PIN 코드는 4-6자리여야 합니다',
  'users.changingPinFor': '{name}의 PIN 변경 중',
  
  // Products
  'products.title': '제품 정의',
  'products.addNew': '새 제품',
  'products.category': '카테고리',
  'products.name': '제품명',
  'products.price': '가격',
  'products.color': '색상',
  'products.active': '활성',
  'products.actions': '작업',
  'products.search': '제품 검색...',
  'products.noProducts': '제품을 찾을 수 없습니다',
  'products.noCategoryProducts': '이 카테고리에 제품이 없습니다',
  'products.emptyCart': '장바구니가 비어 있습니다',
  
  // Service Types
  'service.tailor': '재봉',
  'service.dryCleaning': '드라이클리닝',
  'service.washing': '세탁',
  'service.ironing': '다림질',
  'service.shoeShine': '구두 닦기',
  'service.carpet': '카펫',
  'service.tailoring': '재봉 수선',
  'service.carpetWashing': '카펫 세탁',
  'service.selectService': '서비스 선택',
  'service.addToCart': '장바구니에 추가',
  'service.total': '합계',
  
  // Common
  'common.yes': '예',
  'common.no': '아니오',
  'common.cancel': '취소',
  'common.confirm': '확인',
  'common.delete': '삭제',
  'common.edit': '편집',
  'common.save': '저장',
  'common.search': '검색',
  'common.loading': '로딩 중...',
  'common.noData': '데이터 없음',
  'common.actions': '작업',
  'common.status': '상태',
  'common.date': '날짜',
  'common.time': '시간',
  'common.total': '합계',
  'common.filter': '필터',
  'common.export': '내보내기',
  'common.print': '인쇄',
  'common.close': '닫기',
  'common.back': '뒤로',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.submit': '제출',
  'common.reset': '재설정',
  'common.create': '생성',
  'common.creating': '생성 중...',
  'common.later': '나중에',
  'common.clear': '지우기',
  'common.copied': '복사됨!',
  'common.copyError': '복사 실패',
  'common.autoDetected': '자동 감지됨',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.pieces': 'pieces',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': '드라이클리닝 관리 시스템',
  'login.tenantId': '회사 ID',
  'login.tenantPlaceholder': '회사-ID (예: acme-clean)',
  'login.tenantIdHelp': '고유한 회사 식별자를 입력하세요',
  'login.continue': '계속 →',
  'login.notMember': '아직 회원이 아니신가요?',
  'login.startTrial': '무료 평가판 시작',
  'login.adminLogin': '🔒 관리자 로그인',
  'login.enterPin': 'PIN 코드를 입력하세요',
  'login.changeTenant': '회사 변경',
  'login.clear': '지우기',
  'login.delete': '삭제',
  'login.login': '로그인',
  'login.loggingIn': '로그인 중...',
  'login.defaultPinOwner': '기본 PIN: <strong>1234</strong> (소유자)',
  'login.defaultPinCashier': '기본 PIN: <strong>0000</strong> (계산원)',
  'login.systemInitializing': '시스템 초기화 중...',
  'login.pinMinLength': 'PIN은 최소 4자리여야 합니다',
  'login.invalidTenantId': '유효한 회사 ID를 입력하세요',
  'login.tenantNotFound': '이 회사 코드를 찾을 수 없습니다. 확인하거나 새 계정을 만드세요.',
  'login.loginFailed': '로그인 실패',
  'login.welcome': '환영합니다, {name}',
  'login.tagline': '드라이클리닝 소프트웨어 — 비즈니스를 위한 스마트하고 쉬운 솔루션',

  // Signup translations
  'signup.title': '무료 평가판 시작',
  'signup.subtitle': '15일 무료, 신용카드 불필요',
  'signup.backToLogin': '로그인 페이지로 돌아가기',
  'signup.companyCode': '회사 코드',
  'signup.companyCodePlaceholder': '예: cleanpro',
  'signup.companyCodeHelp': '이 코드는 시스템 로그인에 사용됩니다',
  'signup.companyCodeMinLength': '회사 코드는 최소 3자여야 합니다',
  'signup.companyName': '회사명',
  'signup.companyNamePlaceholder': '회사명',
  'signup.companyNameRequired': '회사명은 필수입니다',
  'signup.fullName': '이름',
  'signup.fullNamePlaceholder': '귀하의 이름',
  'signup.fullNameRequired': '이름은 필수입니다',
  'signup.phone': '전화번호',
  'signup.phonePlaceholder': '+82 10-1234-5678',
  'signup.validPhoneRequired': '유효한 전화번호를 입력하세요',
  'signup.email': '이메일',
  'signup.emailPlaceholder': 'example@company.com',
  'signup.validEmailRequired': '유효한 이메일 주소를 입력하세요',
  'signup.createAccount': '계정 생성',
  'signup.creating': '생성 중...',
  'signup.terms': '계정을 생성함으로써 서비스 약관 및 개인정보 보호정책에 동의합니다.',
  'signup.success': '등록 성공! 로그인 정보가 이메일 주소로 전송되었습니다.',
  'signup.successTitle': '등록 성공!',
  'signup.successMessage': '계정이 성공적으로 생성되었습니다.',
  'signup.emailSent': '로그인 정보가 이메일 주소로 전송되었습니다.',
  'signup.redirecting': '로그인 페이지로 리디렉션 중...',
  'signup.startupPackageLoaded': '시작 패키지 로드됨!',
  'signup.products': '제품',
  'signup.customers': '고객',
  'signup.users': '사용자',
  'signup.demoDataReady': '✨ 데모 데이터가 준비되었습니다. 즉시 사용을 시작할 수 있습니다!',
  'signup.loginInfo': '📧 로그인 정보',
  'signup.loginInfoSent': '💡 이 정보는 이메일 주소로도 전송되었습니다',
  'signup.loginNow': '지금 로그인 →',
  'signup.hints.companyCode': '로그인에 사용',
  'signup.hints.country': '국가가 자동으로 감지되었습니다. 다른 국가를 선택할 수 있습니다.',
  'signup.freeTrial': '🎉 15일 무료 체험 - 신용카드 필요 없음!',
  'toast.productsLoadError': '제품 로드 실패',
  'toast.statsLoadError': '통계 로드 실패',
  'toast.orderDetailsLoadError': '주문 상세 로드 실패',
  'toast.orderLoadError': '주문 로드 실패',
  'toast.deliveryBeforeToday': '배송일은 오늘 이후여야 합니다',
  'toast.customerOpenOrders': '고객에게 {count}개의 미결제 주문이 있습니다',
  'toast.customerDebt': '고객에게 {amount}의 미수금이 있습니다',
  'toast.customerSaved': '고객 저장됨',
  'toast.customerSaveError': '고객 저장 실패',
  'toast.customerUpdated': '고객 업데이트됨',
  'toast.customerUpdateError': '고객 업데이트 실패',
  'toast.customerExistingSelected': '기존 고객 선택됨',
  'toast.productAddedToCart': '제품이 장바구니에 추가되었습니다',
  'toast.productAdded': '제품 추가됨',
  'toast.productDetailsUpdated': '제품 상세 업데이트됨',
  'toast.priceUpdated': '가격 업데이트됨',
  'toast.selectAtLeastOneService': '최소 하나 이상의 서비스를 선택하십시오',
  'toast.selectCustomer': '고객을 선택하십시오',
  'toast.addProduct': '제품을 추가하십시오',
  'toast.addressRequiredForDelivery': '배달을 위해 고객 주소가 필요합니다',
  'toast.orderSaved': '주문 저장됨',
  'toast.orderSaveError': '주문 저장 실패',
  'toast.cardPaymentSuccess': '카드 결제 성공!',
  'toast.cardPaymentError': '카드 결제 실패',
  'toast.paymentFailedTryAgain': '결제 실패. 다시 시도하십시오.',
  'toast.paymentStatusCheckFailed': '결제 상태를 확인할 수 없습니다.',
  'toast.customerPhoneNotFound': '고객 전화번호를 찾을 수 없습니다',
  'toast.whatsappSent': 'WhatsApp 메시지 전송됨! ✅',
  'toast.whatsappFailed': 'WhatsApp 메시지 전송 실패',
  'toast.orderUpdateError': '주문 업데이트 실패',
  'toast.searchError': '검색 오류',
  'toast.orderNotFound': '주문을 찾을 수 없습니다',
  'toast.editCancelled': '편집 취소됨',
  'toast.noEditPermission': '과거 주문을 편집할 권한이 없습니다',
  'toast.selectAtLeastOneOperation': '최소 하나 이상의 작업을 선택하십시오',
  'toast.tailorAddedToCart': '수선 작업이 장바구니에 추가되었습니다',
  'toast.enterValidArea': '유효한 면적을 입력하십시오',
  'toast.enterValidAmount': '유효한 금액을 입력하십시오',
  'toast.amountExceedsRemaining': '금액은 잔액을 초과할 수 없습니다',
  'toast.fillAllCardInfo': '모든 카드 정보를 입력하십시오',
  'toast.invalidCardNumber': '유효하지 않은 카드 번호',
  'toast.invalidMonth': '유효하지 않은 월 (1-12 사이여야 함)',
  'toast.invalidYear': '유효하지 않은 연도',
  'toast.invalidCvc': '유효하지 않은 CVC',

  // 누락된 공통 키
  'common.allYears': '전체 연도',
  'common.autoDetected': '자동 감지됨',
  'common.cancelled': '취소됨',
  'common.clear': '지우기',
  'common.items': '항목',
  'common.loadError': '불러올 수 없습니다',
  'common.none': '없음',
  'common.paid': '결제됨',
  'common.searchError': '검색 오류',
  'common.searchResults': '(검색 결과)',
  'common.unit': '단위',
  'common.year': '연도',

  // 계좌 명세서
  'accountStatement.allTime': '전체 기간',
  'accountStatement.customer': '고객',
  'accountStatement.customerReceipts': '고객 영수증',
  'accountStatement.noData': '계좌 명세서가 없습니다',
  'accountStatement.noReceipts': '영수증이 없습니다',
  'accountStatement.payments': '결제',
  'accountStatement.period': '기간',
  'accountStatement.printStatement': '명세서 인쇄',
  'accountStatement.receipts': '영수증',
  'accountStatement.remaining': '잔액',
  'accountStatement.statement': '계좌 명세서',
  'accountStatement.totalPaid': '총 결제액',

  // 속성
  'attributes.color': '색상',
  'attributes.deleteError': '속성을 삭제할 수 없습니다',
  'attributes.deleted': '속성이 삭제되었습니다',
  'attributes.name': '속성 이름',
  'attributes.noAttributes': '정의된 속성이 없습니다',
  'attributes.saveError': '속성을 저장할 수 없습니다',
  'attributes.saved': '속성이 저장되었습니다',
  'attributes.value': '값',

  // 고객 명세서
  'customerStatement.receiptDelivered': '배달됨',
  'customerStatement.receiptOpen': '미결제',

  // 고객
  'customers.add': '고객 추가',
  'customers.adres': '주소',
  'customers.cannotDeleteWithOrders': '주문이 있는 고객은 삭제할 수 없습니다',
  'customers.legacyHidden': '숨김 (구버전)',
  'customers.notFound': '고객을 찾을 수 없습니다',
  'customers.phoneMissing': '전화번호가 없습니다',
  'customers.telefon': '전화',
  'customers.telefon2': '전화 2',

  // 손상
  'damage.add': '손상 추가',
  'damage.description': '설명',
  'damage.location': '위치',
  'damage.noPhoto': '사진 없음',
  'damage.photo': '사진',
  'damage.saveError': '손상 보고서를 저장할 수 없습니다',
  'damage.saved': '손상 보고서가 저장되었습니다',
  'damage.severity': '심각도',
  'damage.title': '손상 보고서',
  'damage.type': '손상 유형',

  // 대시보드
  'dashboard.allTime': '전체 기간',
  'dashboard.referral.button': '초대 링크 복사',
  'dashboard.referral.desc': '초대한 업체가 가입하면 1개월 추가!',
  'dashboard.referral.title': '친구 초대',

  // 배달
  'delivery.complete': '배달',
  'delivery.deliveredItems': '배달된 항목',
  'delivery.deliveredProducts': '배달된 제품',
  'delivery.error': '배달 오류',
  'delivery.noOrders': '주문이 없습니다',
  'delivery.success': '배달 성공',

  // 배달 목록
  'deliveryList.address': '주소',
  'deliveryList.cancelButton': '취소',
  'deliveryList.cancelTitle': '주문 취소',
  'deliveryList.complete': '완료',
  'deliveryList.completed': '완료됨',
  'deliveryList.delivered': '배달됨',
  'deliveryList.driver': '드라이버',
  'deliveryList.items': '항목',
  'deliveryList.orderCancelled': '주문이 취소되었습니다',
  'deliveryList.orderDelivered': '주문이 배달되었습니다',
  'deliveryList.pending': '대기 중',
  'deliveryList.phone': '전화',
  'deliveryList.selectDriver': '드라이버 선택',
  'deliveryList.status': '상태',
  'deliveryList.title': '배달 목록',

  // 드라이버
  'driver.searchHint': '2자 이상 입력하세요',
  'driver.searchPlaceholder': '영수증 번호, 이름 또는 전화번호...',

  // 푸터
  'footer.euServers': 'EU 서버',
  'footer.gdpr': 'GDPR 준수',

  // 청구서
  'invoices.downloading': '다운로드 중...',

  // 로그인
  'login.credentialsTitle': '로그인 정보',
  'login.enterCredentials': '로그인 정보 입력',
  'login.forget': '비밀번호를 잊으셨나요?',
  'login.saveCredentialsNote': '로그인 정보가 안전하게 저장되었습니다',
  'login.tagline': '세탁 소프트웨어 — 비즈니스를 위한 스마트한 솔루션.',
  'login.usernamePlaceholder': '사용자 이름 입력...',

  // 메뉴
  'menu.driverPickup': '드라이버 픽업',
  'menu.hardware': '하드웨어',
  'menu.payment': '결제',
  'menu.reportsCharts': '보고서 및 차트',

  // 내비게이션
  'nav.logout': '로그아웃',
  'nav.user': '사용자',

  // 주문
  'order.amount': '금액',
  'order.homeDelivery': '배달',
  'order.processing': '처리 중...',
  'orderCreate.selectOperation': '작업 선택',
  'orderCreate.selectedOperations': '선택된 작업',

  // 결제
  'payment.bank': '계좌이체',
  'payment.collect': '수금',
  'payment.credit': '외상',
  'payment.free': '무료',
  'payment.paymentCare': '계정 결제',
  'payment.paymentsSaved': '결제가 저장되었습니다',
  'payment.saveError': '결제를 저장할 수 없습니다',
  'payment.saved': '결제가 저장되었습니다',
  'payment.split': '분할 결제',

  // 플레이스홀더
  'placeholder.customerAddress': '주소 입력...',
  'placeholder.customerEmail': '이메일 입력...',
  'placeholder.customerName': '이름 입력...',
  'placeholder.customerNotes': '메모 입력...',
  'placeholder.customerPhone': '전화번호 입력...',

  // 가격 설정
  'pricing.amount': '금액',
  'pricing.enterPrice': '가격 입력',
  'pricing.percent': '퍼센트',

  // 제품
  'product.damage': '손상',
  'product.stain': '얼룩',

  // 영수증
  'receipt.addressLabel': '주소',
  'receipt.allYears': '전체 연도',
  'receipt.area': '면적',
  'receipt.backButton': '뒤로',
  'receipt.buyCredits': '크레딧 구매',
  'receipt.cancelled': '취소됨',
  'receipt.cancelledBanner': '이 주문은 취소되었습니다',
  'receipt.cancelledBy': '취소자',
  'receipt.cancelledDate': '취소 날짜',
  'receipt.cancelledReason': '취소 사유',
  'receipt.card': '카드',
  'receipt.cash': '현금',
  'receipt.change': '거스름돈',
  'receipt.creditsFinished': 'WhatsApp 크레딧이 소진되었습니다!',
  'receipt.customer': '고객',
  'receipt.customerInfo': '고객 정보',
  'receipt.customerName': '고객 이름',
  'receipt.deliveryDate': '배달일',
  'receipt.discount': '할인',
  'receipt.freeOfCharge': '무료',
  'receipt.generalTotal': '합계',
  'receipt.grandTotal': '최종 합계',
  'receipt.homeDelivery': '배달',
  'receipt.invalid': '유효하지 않은 영수증',
  'receipt.items': '항목',
  'receipt.label': '라벨',
  'receipt.markAsDelivered': '배달됨으로 표시',
  'receipt.markAsReady': '준비됨으로 표시',
  'receipt.messageFailed': '메시지 전송 실패',
  'receipt.messageSent': '메시지가 전송되었습니다!',
  'receipt.new': '새 영수증',
  'receipt.noReceiptFound': '영수증을 찾을 수 없습니다',
  'receipt.notes': '메모',
  'receipt.onlyProEnterprise': 'Pro/Enterprise만',
  'receipt.orderMarkedDelivered': '주문이 배달됨으로 표시되었습니다',
  'receipt.orderMarkedReady': '주문이 준비됨으로 표시되었습니다',
  'receipt.orderNumber': '주문 번호',
  'receipt.paid': '결제됨',
  'receipt.partialPayment': '부분 결제',
  'receipt.paymentMethod': '결제 방법',
  'receipt.phone': '전화',
  'receipt.phoneNotFound': '전화번호를 찾을 수 없습니다',
  'receipt.piece': '개',
  'receipt.preview': '미리보기',
  'receipt.printError': '인쇄 오류',
  'receipt.printerConnectError': '프린터에 연결할 수 없습니다',
  'receipt.remaining': '잔액',
  'receipt.remainingCredits': '남은 크레딧',
  'receipt.reprint': '재인쇄',
  'receipt.scanQR': 'QR 코드 스캔',
  'receipt.searchAll': '전체',
  'receipt.searchBy': '검색 기준',
  'receipt.searchName': '고객 이름',
  'receipt.searchPhone': '전화',
  'receipt.searchReceipt': '영수증 번호',
  'receipt.searchTitle': '영수증 검색',
  'receipt.sessionNotFound': '세션을 찾을 수 없습니다. 다시 로그인하세요.',
  'receipt.status': '상태',
  'receipt.thermalPrinter': '열전사 프린터',
  'receipt.thisReceiptCancelled': '이 영수증은 취소되었습니다',
  'receipt.unknownError': '알 수 없는 오류',
  'receipt.whatsappNotConnected': 'WhatsApp이 연결되지 않았습니다!',
  'receipt.year': '연도',

  // 보고서
  'reports.averageOrder': '평균 주문',
  'reports.ordersCount': '주문 수',
  'reports.salesReport': '매출 보고서',
  'reports.totalSales': '총 매출',

  // 서비스
  'service.carpetShort': '카펫',
  'service.dryCleaningShort': '드라이클리닝',
  'service.ironingShort': '다림질',
  'service.shoeShineShort': '신발',
  'service.tailoringShort': '수선',
  'service.washingShort': '세탁',

  // 설정
  'settings.africa': '아프리카',
  'settings.americas': '아메리카',
  'settings.asia': '아시아',
  'settings.asiaPacific': '아시아태평양',
  'settings.europe': '유럽',
  'settings.integrations': '통합',
  'settings.notifications': '알림',
  'settings.printer': '프린터',
  'settings.printerConnected': '프린터 연결됨',
  'settings.printerNotConnected': '프린터 미연결',
  'settings.printerSettings': '프린터 설정',
  'settings.saveError': '설정을 저장할 수 없습니다',
  'settings.saved': '설정이 저장되었습니다',
  'settings.testPrint': '테스트 인쇄',
  'settings.turkey': '터키',

  // 회원가입
  'signup.errors.companyCodeRequired': '회사 코드가 필요합니다',
  'signup.errors.companyNameRequired': '회사명이 필요합니다',
  'signup.errors.emailInvalid': '잘못된 이메일 주소',
  'signup.errors.emailRequired': '이메일이 필요합니다',
  'signup.errors.ownerNameRequired': '소유자 이름이 필요합니다',
  'signup.errors.signupFailed': '회원가입 실패',
  'signup.referral.bonus': '추천 보너스',
  'signup.referral.title': '초대 코드',

  // 상태
  'status.cancelled': '취소됨',
  'status.delivered': '배달됨',
  'status.pending': '대기 중',
  'status.pickup_in_progress': '픽업 진행 중',
  'status.pickup_pending': '픽업 대기',
  'status.ready': '준비됨',
  'status.received': '접수됨',

  // 구독
  'subscription.buyNow': '지금 구매',
  'subscription.cancel': '구독 취소',
  'subscription.contactSupport': '지원팀 문의',
  'subscription.currentPlan': '현재 플랜',
  'subscription.currentUsage': '현재 사용량',
  'subscription.daysLeft': '일 남음',
  'subscription.endDate': '종료일',
  'subscription.expired': '만료됨',
  'subscription.expiresOn': '만료일',
  'subscription.features': '기능',
  'subscription.loading': '구독 불러오는 중...',
  'subscription.monthly': '월간',
  'subscription.monthlyLimit': '월간 한도',
  'subscription.noSubscription': '활성 구독 없음',
  'subscription.payNow': '지금 결제',
  'subscription.plan': '플랜',
  'subscription.pro': 'Pro',
  'subscription.renew': '갱신',
  'subscription.renewNow': '지금 갱신',
  'subscription.startDate': '시작일',
  'subscription.title': '구독',
  'subscription.trial': '체험',
  'subscription.trialDaysLeft': '체험 일 남음',
  'subscription.upgrade': '업그레이드',
  'subscription.yearly': '연간',

  // 지원 티켓
  'tickets.title': '지원 티켓',
  'tickets.newTicket': '새 티켓',
  'tickets.noTickets': '티켓이 없습니다',
  'tickets.subject': '제목',
  'tickets.description': '설명',
  'tickets.created': '지원 티켓이 생성되었습니다',
  'tickets.createError': '티켓을 생성할 수 없습니다',
  'tickets.loadError': '티켓을 불러올 수 없습니다',
  'tickets.messages': '메시지',
  'tickets.typeMessage': '메시지 입력...',
  'tickets.closed': '종료됨',
  'tickets.admin': '관리자',
  'tickets.ratingSubmitted': '평가가 저장되었습니다, 감사합니다!',
  'tickets.translationError': '번역 오류',
  'tickets.status.open': '열림',
  'tickets.status.closed': '종료됨',
  'tickets.rating.veryBad': '매우 나쁨',
  'tickets.rating.bad': '나쁨',
  'tickets.rating.okay': '보통',
  'tickets.rating.good': '좋음',
  'tickets.rating.excellent': '매우 좋음',

  // Toast 알림
  'toast.logoTooLarge': '로고 파일이 너무 큽니다',
  'toast.logoUploadError': '로고를 업로드할 수 없습니다',
  'toast.uploadingLogo': '로고 업로드 중...',

  // WhatsApp
  'whatsapp.title': 'WhatsApp',
  'whatsapp.connect': 'WhatsApp 연결',
  'whatsapp.disconnect': '연결 해제',
  'whatsapp.connected': '연결됨',
  'whatsapp.scanQR': 'QR 코드 스캔',
  'whatsapp.status': '상태',
  'whatsapp.credits': '크레딧',
  'whatsapp.buyCredits': '크레딧 구매',
  'whatsapp.creditPackages': '크레딧 패키지',
  'whatsapp.messages': '메시지',
  'whatsapp.creditsRemaining': '남은 크레딧',
  'whatsapp.noCredits': '크레딧이 없습니다',
  'whatsapp.sendTest': '테스트 메시지 전송',
  'whatsapp.testSent': '테스트 메시지가 전송되었습니다',
  'whatsapp.testFailed': '테스트 메시지 전송 실패',
  'whatsapp.templates': '템플릿',
  'whatsapp.template': '템플릿',
  'whatsapp.preview': '미리보기',
  'whatsapp.save': '템플릿 저장',
  'whatsapp.saved': '템플릿이 저장되었습니다',
  'whatsapp.orderReady': '주문 준비됨',
  'whatsapp.orderDelivered': '주문 배달됨',
  'whatsapp.receiptCreated': '영수증이 생성되었습니다',

  // Z 보고서
  'zReport.title': 'Z 보고서',
  'zReport.byEmployee': '직원별',
  'zReport.byProduct': '제품별',
  'zReport.byService': '서비스별',
  'zReport.cardPayments': '카드 결제',
  'zReport.cashIn': '수입',
  'zReport.cashOut': '지출',
  'zReport.cashPayments': '현금 결제',
  'zReport.closingBalance': '마감 잔액',
  'zReport.creditPayments': '외상 결제',
  'zReport.custom': '사용자 정의',
  'zReport.daily': '일별',
  'zReport.endDate': '종료일',
  'zReport.freeOrders': '무료 주문',
  'zReport.generateReport': '보고서 생성',
  'zReport.monthly': '월별',
  'zReport.newCustomers': '신규 고객',
  'zReport.openingBalance': '시작 잔액',
  'zReport.printReport': '보고서 인쇄',
  'zReport.returningCustomers': '재방문 고객',
  'zReport.selectDate': '날짜 선택',
  'zReport.serviceBreakdown': '서비스별 내역',
  'zReport.startDate': '시작일',
  'zReport.totalCollected': '총 수금액',
  'zReport.totalItems': '총 항목 수',
  'zReport.totalOrders': '총 주문 수',
  'zReport.totalRefunds': '총 환불액',
  'zReport.totalRevenue': '총 수익',
  'zReport.transferPayments': '이체 결제',
  'zReport.weekly': '주별',
  'zreport.card': '카드',
  'zreport.cash': '현금',
  'zreport.date': '날짜',
  'zreport.orders': '주문',
  'zreport.print': '인쇄',
  'zreport.title': 'Z 보고서',
  'zreport.total': '합계',
  'expenses.expenseType': '비용 유형',
  'expenses.allBranches': '모든 지점',
  'expenses.noBranch': '지점 없음',
  'expenses.allTypes': '모든 유형',
  'expenses.categoryBy': '카테고리별',
  'expenses.records': '건',
  'expenses.exportExcel': 'Excel',
  'expenses.excelError': 'Excel 파일을 만들 수 없습니다',
  'expenses.branchSelect': '지점 선택',
  'expenses.noBranchSelected': '— 지점 미선택 —',
  'expenses.myBranch': '내 지점',
  'expenses.canOnlyDeleteToday': '오늘 입력한 비용만 삭제할 수 있습니다.',
  'subscription.referralDesc': '초대한 친구가 가입하여 회원이 되면 1개월이 추가됩니다! 초대만 보내는 것으로는 부족합니다.',
};
